export default __webpack_public_path__ + "static/media/SA.42dd744d.svg";